import script from "./Node.vue?vue&type=script&setup=true&lang=ts"
export * from "./Node.vue?vue&type=script&setup=true&lang=ts"

import "./Node.vue?vue&type=style&index=0&id=63ded336&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Profectus/Profectus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63ded336"]])

export default __exports__